import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import SendToSign from './SendToSign'
import Status from './Status'
import UpdateInformation from './UpdateInformation'
import UpdateSigners from './UpdateSigners'
import UpdateViewers from './UpdateViewers'
import AnnexedDocuments from './AnnexedDocuments'
import Ready from './Ready'
import AdvancedSettings from './AdvancedSettings'
import withOrganization from 'App/Decorators/withOrganization'
import isAdmin from 'App/Decorators/isAdmin'
import LogoLoading from 'src/App/components/LogoLoading'
import UpdateFea from './UpdateFea'
import UpdateFace from './UpdateFace'
import autobind from 'autobind-decorator'
import sleep from 'orionsoft-parts/lib/helpers/sleep'

@isAdmin
@withGraphQL(
  gql`
    query getDocument($documentId: ID) {
      document(documentId: $documentId) {
        _id
        name
        isPersonal
        ready
        feaReady
        faceReady
        bioReady
        signatureRequested
        feaSignAuthorization
        hasPreview
        faceSignAuthorization
        isMyFeaTurn
        feaNextSigner
        requireSignersOrder
        tags
        signersRoles {
          name
        }
        signers {
          name
          email
        }
        feaSigners {
          id
          name
          email
          signData {
            size
          }
        }
        faceSigners {
          id
          name
          email
        }
        requireTwoFactor
        documentOwner
        transactionId
        filledBy {
          userId
        }
        rejected {
          reason
        }
        redirectUrl
        signAuthorization
        ...documentViewStatus
        ...documentUpdateInformation
        ...documentSendToSign
        ...documentAdvancedSettings
        ...documentAnnexeds
      }
    }
    ${AnnexedDocuments.fragment}
    ${Status.fragment}
    ${UpdateInformation.fragment}
    ${UpdateSigners.fragment}
    ${SendToSign.fragment}
    ${AdvancedSettings.fragment}
  `,
  { loading: <LogoLoading /> }
)
@withOrganization
export default class Document extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool
  }
  state = { redirected: false }

  renderResume() {
    //console.log("bioReady: " + this.props.document.bioReady );
    let feaNoReady = this.props.document.feaReady === false;
    let bioNoReady = this.props.document.bioReady === false;
    let faceNoReady = this.props.document.faceReady === false;
    
    //console.log("faceReady es ", this.props.document.faceReady);
    //console.log("faceEstatus es ", faceNoReady);
    //console.log("faceSigners es ", this.props.document.faceSigners);
    if (this.props.document.ready && !feaNoReady && !bioNoReady && !faceNoReady) {
      console.log("Esta listo!");
      return (
        <Ready
          document={this.props.document}
          organization={this.props.organization}
        />
      )
    } else if (this.props.document.signatureRequested) {
      console.log("Algo falta pero ya fue enviado a firmar!");
      return (
        <Status
          document={this.props.document}
          organization={this.props.organization}
        />
      )
    } else {
      return (
        <SendToSign
          document={this.props.document}
          organization={this.props.organization}
        />
      )
    }
  }

  renderUpdateInformation() {
    return (
      <UpdateInformation
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  renderUpdateSigners() {
    if (this.props.document.signatureRequested) return
    if (this.props.document.isPersonal) return
    return (
      <UpdateSigners
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  renderUpdateFea() {
    if (this.props.document.signatureRequested) return
    return (
      <UpdateFea
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  renderUpdateFace() {
    if (this.props.document.signatureRequested) return
    return (
      <UpdateFace
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  renderUpdateViewers() {
    return (
      <UpdateViewers
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  renderAnnexedDocuments() {
    return (
      <AnnexedDocuments
        document={this.props.document}
        organization={this.props.organization}
      />
    )
  }

  @autobind
  async tryRedirect(){
    if(!this.state.redirected){
      console.log("Redirigiendo a " + this.props.document.redirectUrl);
      await sleep(100);  
      this.setState({ redirected: true })
      await sleep(3000);
      window.location.href = this.props.document.redirectUrl;
    } else {
      console.log("Ya redirigi.....");
    }
  }

  renderRedirectText(){
    if(this.props.location.query.feaDone && this.props.document.redirectUrl && this.state.redirected){
      return(
        <div>
          <label>Redirigiendo a sistema de origen...</label>
        </div>
      )
    }
  }

  render() {
    const doc = this.props.document
    const admin = this.props.admin

    if (
      !this.props.document ||
      (this.props.admin !== 'admin' && this.props.url)
    ) {
      return (
        <div className={styles.container}>
          <LogoLoading />
        </div>
      )
    }else{
      console.log("Tengo doc para mostrar");
      //alert(JSON.stringify(this.props.location.query));
      if(this.props.location.query.feaDone && this.props.document.redirectUrl ){
        this.tryRedirect();
      }
      if(!doc.documentOwner || !doc.documentOwner && !admin) {
        console.log('Estos son los datos', doc.documentOwner, !admin)
        return (
          <div className={styles.container}>
            {this.renderRedirectText()}
            <div className="content">
              {this.renderResume()}
              {this.renderAnnexedDocuments()}
            </div>
          </div>
        )
      }
      if (this.props.document.documentOwner || this.props.organization) {
    
        return (
          <div className={styles.container}>
            {this.renderRedirectText()}
            <div className="content">{this.renderResume()}</div>
            {this.renderUpdateInformation()}
            {this.renderAnnexedDocuments()}
            {this.renderUpdateViewers()}
            {this.renderUpdateFea()}
            {this.renderUpdateFace()}
            {this.renderUpdateSigners()}
          </div>
        )
      } else {
        return (
          <div className={styles.container}>
            <div className="content">{this.renderResume()}</div>
          </div>
        )
      }
    } 
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/index.js